import { Button } from "@mui/material";
import { Field, Formik, Form } from "formik";
import { TextField } from "formik-material-ui";
import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import "./topics.css";
import { db } from "../config/Firebase";
import { addDoc, collection } from "firebase/firestore";
import * as Yup from "yup";
import { useFirebaseDataContext } from "../context/FirebaseContextProvider";
import AlertDisplay from "../../../../componenets/AlertDisplay";

const CreateTopics = () => {
  const {
    addTpoic,
    getAllTopicsData,
    showAlert,
    alertText,
    alertType,
    setShowAlert,
  } = useFirebaseDataContext();

  const initialValues = {
    department: "",
    topicTitle: "",
    description: "",
    votes: 0,
  };
  const onSubmit = (values, onSubmitProps) => {
    console.log("formData", values);
    addTpoic(values);
    getAllTopicsData();
    onSubmitProps.resetForm();
  };
  const validationSchema = Yup.object({
    department: Yup.string().required("❗Required"),
    topicTitle: Yup.string().required("❗Required"),
    description: Yup.string().required("❗Required"),
  });

  return (
    <>
      <Container style={{ margin: "auto" }}>
        <Card>
          <Card.Header>Create A Topic</Card.Header>
          <Card.Body>
            {showAlert && alertType && alertText && (
              <AlertDisplay
                alertType={alertType}
                alertText={alertText}
                setShowAlert={setShowAlert}
              />
            )}
            <Card.Title>Create A Technology Topic Card</Card.Title>
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
            >
              {(formik) => {
                return (
                  <>
                    <Form
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        padding: "10px",
                        margin: "10px",
                      }}
                    >
                      <Container fluid>
                        <Row className="m-2">
                          <Field
                            name="topicTitle"
                            type="text"
                            component={TextField}
                            placeholder="Topic Title"
                            className="fieldinput"
                          />{" "}
                        </Row>
                        <Row className="m-2">
                          <Field
                            name="department"
                            type="text"
                            component={TextField}
                            placeholder="Department Name"
                            className="fieldinput"
                          />{" "}
                        </Row>
                        <Row className="m-2">
                          <Field
                            name="description"
                            type="text"
                            component={TextField}
                            placeholder="Description"
                            className="fieldinput"
                          />{" "}
                        </Row>
                        <Row className="m-2">
                          <div className="d-flex flex-row justify-content-between">
                            <Button
                              variant="contained"
                              color="primary"
                              type="button"
                              style={{ marginTop: "10px" }}
                              onClick={() => formik.resetForm()}
                            >
                              Reset
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              type="submit"
                              style={{ marginTop: "10px" }}
                            >
                              Submit
                            </Button>
                          </div>
                        </Row>
                      </Container>
                    </Form>
                    {/* todo create topic form */}
                  </>
                );
              }}
            </Formik>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default CreateTopics;
